// eslint-disable-next-line import/prefer-default-export
export const SET_CURRENT_SYSTEM_CONFIGURATION = 'current-system-configuration/SET_CURRENT_SYSTEM_CONFIGURATION';
